import configdata from "./config.json";
import httpService from "./httpService";

let apiEndpoint = "";
if (process.env.NODE_ENV !== "production") {
  apiEndpoint = `${configdata.apiUrl}/subscribedusers`;
} else {
  apiEndpoint = `${configdata.herokuUrl}/subscribedusers`;
}

export async function subscribedUsers(data) {
  const response = await httpService.post(
    `${apiEndpoint}/postSubscribedUsers`,
    data
  );
  console.log(data);
  return response;
}

export async function blogSubscribedUsers(data) {
  const response = await httpService.post(
    `${apiEndpoint}/postBlogSubscribedUsers`,
    data
  );
  console.log(data);
  return response;
}


export default { subscribedUsers, blogSubscribedUsers };
